import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  width?: string;
  fill?: string;
  className?: string;
}

const StarWithoutBg: React.FC<CustomIconProps> = ({
  width,
  fill,
  className,
}) => (
  <svg
    width={width ?? '14'}
    height={width ?? '14'}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M5.7174 0.892991C6.15798 -0.297665 7.84202 -0.297663 8.28261 0.892994L9.3674 3.8246C9.50592 4.19894 9.80106 4.49408 10.1754 4.6326L13.107 5.7174C14.2977 6.15798 14.2977 7.84202 13.107 8.28261L10.1754 9.3674C9.80106 9.50592 9.50592 9.80106 9.3674 10.1754L8.28261 13.107C7.84202 14.2977 6.15798 14.2977 5.7174 13.107L4.6326 10.1754C4.49408 9.80106 4.19894 9.50592 3.8246 9.3674L0.892991 8.28261C-0.297665 7.84202 -0.297663 6.15798 0.892994 5.7174L3.8246 4.6326C4.19894 4.49408 4.49408 4.19894 4.6326 3.8246L5.7174 0.892991Z'
      fill={fill ?? 'white'}
    />
  </svg>
);

export default StarWithoutBg;
